import { RouterLink } from '@angular/router';
// angular import
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// angular material import

// third party import
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TranslateModule } from '@ngx-translate/core';

// project import
import { CardComponent } from 'src/app/@theme/components/card/card.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

const BootrstrapModules: any[] = [
  NgbTooltip
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BootrstrapModules,
    FormsModule,
    NgScrollbarModule,
    CardComponent,
    RouterLink,
  ],
  exports: [BootrstrapModules, FormsModule, NgScrollbarModule, TranslateModule, CardComponent, CommonModule, RouterLink]
})
export class BaseModule { }
